import { buildSecurityAgentPrompt } from '../lib/securityNonce'
import { MonitoringSetupErrorSchema } from '../schemas/projectMonitoring'
import { useState } from 'react'
import { AgentPromptBox } from './AgentPrompt'
import { useGetMonitoringSetupQuery } from '../services/sessionMonitoringApi'

export default function ProjectMonitoringSetup({ projectId }: { projectId: string }) {
  const query = useGetMonitoringSetupQuery(projectId)
  const [copied, setCopied] = useState(false)
  const [copyError, setCopyError] = useState(false)
  const credential = query.currentData
  const instructions = credential ? `Set up Self Healing for my app using Replay QA project ${projectId}.

Install FullStory recording before rendering the app UI. Inspect any existing recorder first and replace its initialization rather than installing a second recorder. Add this module script to the app entry point:

<script type="module">
import { startMonitoring } from '${new URL(credential.endpoint).origin}/qa-monitoring-v1.js';
startMonitoring(${JSON.stringify({ endpoint: credential.endpoint, key: credential.key, orgId: credential.org_id, region: credential.region }, null, 2)});
</script>

The upload credential above is ready to use. Allow the QA origin in script-src and connect-src if the app uses CSP. Preserve FullStory masking and privacy rules.

${credential.ownership ? buildSecurityAgentPrompt(credential.ownership.target_url, credential.ownership.nonce) + '\n\nDeploy the ownership file together with the recorder. QA checks it automatically when sessions connect.\n' : ''}

Open the app, interact with it, and verify that a real session reaches this project. Explain anything still requiring my action. Leave project onboarding unchanged.` : ''
  return <div className="monitoring-setup">
    <p>Give these instructions to the coding agent working on your app.</p>
    {query.isLoading && <p role="status">Preparing setup instructions…</p>}
    {query.isError && <p role="alert">{MonitoringSetupErrorSchema.safeParse(query.error).data?.data.error ?? 'Self-healing setup is unavailable.'} <button onClick={() => void query.refetch()}>Retry</button></p>}
    {credential && <div className="fs-mask"><AgentPromptBox prompt={instructions} copied={copied} analyticsEvent="self-healing-setup-prompt-copy" onCopy={() => {
      setCopyError(false)
      void navigator.clipboard.writeText(instructions).then(() => setCopied(true)).catch(() => setCopyError(true))
    }} /></div>}
    {copyError && <p role="alert">Could not copy. Select and copy the prompt above.</p>}
  </div>
}
